<template>
  <div class="dataset-share-edit-dailog dialog col-block">
    <customForm
      :layoutType="'grid'"
      :groupCount="6"
      :gap="'0px 16px'"
      :init="shareData"
      :alerts="{}"
      :forms="formOptions['field1']"
      @change="(result, validate, errors) => formOnChange('field1', result, validate, errors)"
    ></customForm>
    <div :style="{ height: '0' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => !onSubmit ? validateEditDatasetShare() : ''">
        <span>{{ $t('COMMON.button.___update') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { putDatasetShare } from '../../api'
import customForm from '../../components/tool/customForm'
import toastMethods from '../../mixins/toastMethods'

export default {
  components: {
    customForm
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      shareData: {},
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    }
  },
  computed: {
    onError () {
      return Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
    },
    // static
    formOptions () {
      return {
        field1: [
          // 1
          {
            title: this.$t('DIALOG.datasetShareEdit.form.title.___user'),
            value: 'user',
            type: 'text',
            displayMode: true,
            grid: 4
          },
          {
            title: this.$t('DIALOG.datasetShareEdit.form.title.___permission'),
            value: 'permission',
            type: 'select',
            options: this.param.permissionOptions,
            grid: 2
          },
          // 2
          {
            title: this.$t('DIALOG.datasetShareEdit.form.title.___email'),
            value: 'email',
            type: 'text',
            displayMode: true,
            grid: 4
          },
          {
            grid: 2
          }
        ]
      }
    }
  },
  created () {
    let shareData = this.param.shareData || this.shareData
    let user = shareData.user
    this.shareData = {
      ...shareData,
      user: [user.first_name, user.last_name].filter(x => x).join(' ') + (user.organization || user.division ? ' (' + [user.organization, user.division].filter(x => x).join(' ') + ')' : ''),
      email: user.email
    }
  },
  methods: {
    formOnChange (field, result, validate, errors) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result = {
        ...this.result,
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      // const isSubmit = !cols
      const validates = {
      }
      for (let col of cols || Object.keys(this.shareData)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    async validateEditDatasetShare () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['custom'] = this.customValidate()
      if (!Object.values(result).includes(false)) {
        await this.editDatasetShare()
      }
      this.onSubmit = false
    },
    async editDatasetShare () {
      try {
        let config = this.$ls.get('userInfo')
        let id = this.shareData.id
        let datasetID = this.param.datasetData.id
        let data = {
          permission: this.result.permission
        }
        await putDatasetShare(id, datasetID, data, config)
        this.$emit('changeModal', {}, true)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/datasetShareEdit.vue